import { ScreenShareControlWrapper } from '../../session/controls/ScreenShareControlWrapper';

export function SessionModeControlButtonWrapper() {
  return <ScreenShareControlWrapper />;
}
